(function (gsap, ScrollTrigger, ScrollToPlugin, helper) {

    if (helper.isReducedMotion()) {
        return;
    }

    const sections = document.querySelectorAll(".u-slide");

    function goToSection(section, anim) {
        // No Scrolljacking on mobile devices because content does not fit into viewport
        if (!helper.isMobile()) {
            gsap.to(window, {
                scrollTo: {y: section, autoKill: false},
                duration: 2
            });
        }

        if(anim) {
            anim.restart();
        }
    }

    sections.forEach(section => {
        const isLastSection = $(section).attr("id") === $(sections).last().attr("id");

        const intoAnim = gsap.timeline({paused: true})
            .from(section.querySelector(".u-slide__left"), {yPercent: 10, duration: 1})
            .from(section.querySelector(".u-slide__left"), {duration: 2, alpha: 0}, "-=1")
            .from(section.querySelector(".u-slide__right"), {xPercent: 50, duration: 1}, "-=1.5")
            .from(section.querySelector(".u-slide__right"), {duration: 2, alpha: 0}, "-=1");

        const reIntoAnim = gsap.timeline({paused: true})
            .fromTo(section.querySelector(".u-slide__right"), {xPercent: -10}, {xPercent: 0, duration: 1})
            .fromTo(section.querySelector(".u-slide__right"), {alpha: 0}, {duration: 2, alpha: 1}, "-=1");

        const leaveAnim = gsap.timeline({paused: true})
            .to(section.querySelector(".u-slide__right"), {xPercent: -10, duration: .5, alpha: 0})
            .to(section.querySelector(".u-slide__right"), {xPercent: -10, duration: 1.5, alpha: 0});

        const leaveAnimReverse = gsap.timeline({paused: true})
            .to(section.querySelector(".u-slide__right"), {xPercent: 50, duration: 1, alpha: .5})
            .to(section.querySelector(".u-slide__right"), {duration: 1, alpha: 0}, "-=.5");

        // Enter section in viewport (scroll down)
        ScrollTrigger.create({
            trigger: section,
            onEnter: () => goToSection(section, intoAnim),
        });

        // Re-enter section in reIntoAnim (scroll up)
        ScrollTrigger.create({
            trigger: section,
            start: "bottom bottom",
            onEnterBack: () => goToSection(section, reIntoAnim),
        });

        // Leave section in viewport (scroll down)
        ScrollTrigger.create({
            trigger: section,
            start: "bottom bottom",
            end: "+=100%",
            onEnter: function () {
                if (!isLastSection && !helper.isMobile()) {
                    leaveAnim.restart();
                }
            },
        });

        // Leave section in viewport (scroll up)
        ScrollTrigger.create({
            trigger: section,
            start: "bottom bottom",
            end: "-=100%",
            onEnterBack: function () {
                if (!helper.isMobile()) {
                    leaveAnimReverse.restart();
                }
            },
        });
    });

})(window.gsap, window.ScrollTrigger, window.ScrollToPlugin, window.kfwHelper);
